module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-03-fe78fc16120dfa35db2fa859b37a7616.jpg";